<template>
  <div id="neopassindex">
    <!-- BEGIN Popup add new neopass -->
    <add-new-neopass-popup
      :add-neopass-display="addNeopassDisplay"
      @close="addNeopassDisplay = -1"
      @open="openPopupNewNeopass"
      @changeStep="
        (numStep) => {
          addNeopassDisplay = numStep;
        }
      "
    />
    <!-- END Popup add new neopass -->

    <!-- BEGIN modal beneficiary rights -->
    <edit-beneficiary-rights-popup
      :is-displayed="isPopupEditBeneficiaryRightsDisplayed"
      @close="changeStateEditBeneficiaryRightsPopup(false)"
      :message-header="messageHeader"
      message-save-success="Les droits du bénéficiaire ont bien été enregistrés."
      :saving="saving"
      :list-modules-pages="listNeopassModulesPages"
      :permissions="permissions"
      :neopass-form-rights="
        ((beneficiaryRightsToEdit || {}).rights || {}).neopassForm || {}
      "
      @saveRights="save_beneficiary_rights"
      @check="
        (options) => {
          if (options.page) {
            //If page name is filled, then check page permission.
            (((((beneficiaryRightsToEdit || {}).rights || {}).neopassForm ||
              {})[options.type] || {})[options.module] || {})[options.page] =
              options.newValue;
          }
          if (!options.page) {
            // else not checked
            ((((beneficiaryRightsToEdit || {}).rights || {}).neopassForm || {})[
              options.type
            ] || {})[options.module] = options.newValue;
          }

          if (options.checkall)
            checkall(options.type, options.module, options.newValue);
          if (options.decheckall)
            decheckall(options.type, options.module, options.newValue);

          if (!options.newValue && options.type == 'read') {
            if (options.page)
              (((
                ((beneficiaryRightsToEdit || {}).rights || {}).neopassForm || {}
              ).edit || {})[options.module] || {})[options.page] =
                options.newValue;
            if (!options.page)
              ((
                ((beneficiaryRightsToEdit || {}).rights || {}).neopassForm || {}
              ).edit || {})[options.module] = options.newValue;
            if (options.checkall)
              checkall('edit', options.module, options.newValue);
            if (options.decheckall)
              decheckall('edit', options.module, options.newValue);
          }
          if (options.newValue && options.type == 'edit') {
            if (options.page)
              (((
                ((beneficiaryRightsToEdit || {}).rights || {}).neopassForm || {}
              ).read || {})[options.module] || {})[options.page] =
                options.newValue;
            if (!options.page)
              ((
                ((beneficiaryRightsToEdit || {}).rights || {}).neopassForm || {}
              ).read || {})[options.module] = options.newValue;

            if (options.checkall)
              checkall('read', options.module, options.newValue);
          }
        }
      "
    />
    <!-- END modal beneficiary rights -->

    <!-- BEGIN Popup detach neopass -->
    <detach-neopass-popup
      :is-displayed="beneficiary_out_display > -1"
      @close="closePopupDetachNeopass"
      @confirmDetach="detachNeopass(neopassToDetach.id)"
      :state="beneficiary_out_display"
      :neopass-to-detach="neopassToDetach"
    />
    <!-- END Popup detach neopass -->

    <div
      class="relative hidden md:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
    >
      <div class="px-12">
        <p class="text-4xl text-gray-900">
          Mes carnets de parcours
        </p>
        <p
          class="mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 pr-48 xl:pr-72"
        >
          Accompagner vos bénéficiaires dans la construction ou le maintien de
          leurs projets personnels et professionnels.<br />
          Vous pouvez éditer ou imprimer vos carnets de parcours.
        </p>
      </div>
      <illustration
        name="Group189"
        class="hidden md:block absolute right-5 xl:right-10 w-60 xl:w-72"
      />
    </div>

    <!-- BEGIN add new + search + sort -->
    <div
      v-if="allowed"
      class="grid grid-cols-2 md:grid-cols-5 2xl:grid-cols-4 gap-4 mt-16 items-center mb-10"
    >
      <div
        class="col-start-1 col-span-1"
        v-if="$can(constants.PERMISSION_NEOPASS_AJOUTER_BENEFICIAIRE)"
      >
        <action-button
          id="add-neopass"
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-pink-600"
          bg-color-square="bg-pink-600"
          icon-color="text-white"
          libelle="AJOUTER UN CARNET"
          :uppercase="true"
          icon="plus-circle"
          :responsive="false"
          type-shadow="shadow-pink"
          @clickAction="openPopupNewNeopass"
        />
      </div>

      <div
        v-if="structures.length > 1"
        class="col-span-1"
      >
        <input-select
          class=""
          name="choice_structure"
          :value="structure"
          @input="
            (newValue) => {
              changeStructureAndReloadInfos(newValue.id);
            }
          "
          :datas="structures"
          libelle=""
          :empty-case="false"
          :value-is-object="true"
          icon="building"
        />
      </div>

      <div
        class="col-start-1 col-span-2 md:col-start-3 md:col-span-3 2xl:col-start-3 2xl:col-span-2 flex w-full space-x-5 items-center"
        id="filter-name"
        @keydown="onKeyDown"
        @keyup="onKeyUp"
      >
        <search-bar
          name="searchBeneficiary"
          libelle=""
          :value="search"
          placeholder="Rechercher un bénéficiaire"
          :big="false"
          :inherits="false"
          :has-border="false"
          @input="
            (newValue) => {
              search = newValue;
            }
          "
        />

        <sort-button
          id="filter-date"
          class="col-span-1 md:col-start-4 md:col-span-1 place-self-end"
          :sort="sort"
          @sorted="
            (sortType) => {
              changeSortType(sortType);
            }
          "
          :responsive="true"
        />
      </div>
    </div>
    <!-- END add new + search + sort -->

    <!-- BEGIN choice number results per page -->
    <div
      v-if="false"
      class="col-start-1 col-span-full flex space-x-5 justify-end items-center mb-5"
    >
      <div>Résultat par page</div>
      <tag
        libelle="10"
        :theme-color="perPage === 10 ? 'indigo' : 'white'"
        :scale-on-hover="true"
        class="cursor-pointer"
        @push="changePerPage(10)"
      />
      <tag
        libelle="20"
        :theme-color="perPage === 20 ? 'indigo' : 'white'"
        :scale-on-hover="true"
        class="cursor-pointer"
        @push="changePerPage(20)"
      />
      <tag
        libelle="50"
        :theme-color="perPage === 50 ? 'indigo' : 'white'"
        :scale-on-hover="true"
        class="cursor-pointer"
        @push="changePerPage(50)"
      />
      <tag
        libelle="100"
        :theme-color="perPage === 100 ? 'indigo' : 'white'"
        :scale-on-hover="true"
        class="cursor-pointer"
        @push="changePerPage(100)"
      />
    </div>
    <!-- END choice number results per page -->

    <div
      v-if="allowed"
      class="relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
    >
      <list-grid
        :list-items="neopass"
        :is-listdisplayed="neopass != null && neopass.length > 0"
      >
        <template
          v-if="neopass"
          #header
        >
          <div
            class="col-start-2 md:col-start-2 xl:col-start-2 xxl:col-start-2 col-span-8 md:col-span-3 xl:col-span-2 xxl:col-span-3 ml-8 md:ml-0 xxl:ml-8"
          >
            Bénéficiaires
          </div>
          <div class="hidden md:block md:col-span-3 2xl:col-span-4">
            Droit d'accès
          </div>
          <div
            class="hidden md:block md:col-span-2 xl:col-span-3 xxl:col-span-2"
          >
            Actions rapides
          </div>
          <div class="col-span-3 md:col-span-3 2xl:col-span-2 md:ml-5 lg:ml-0">
            Modifier <span class="hidden md:inline">le carnet</span>
          </div>
        </template>

        <template #errorCases>
          <div
            v-if="neopass.length === 0"
            class="flex flex-col justify-center items-center w-full my-8"
          >
            <div class="text-pink-600 text-center text-lg mb-8">
              Aucun Neopass !
            </div>
            <div class="text-indigo-600 text-center text-base mb-8">
              Il n'y a aucun Neopass trouvé
            </div>
            <div>
              <illustration name="no_result" />
            </div>
          </div>
        </template>

        <!-- BEGIN list of beneficiaries -->
        <template #accordionDescription="{ item, num }">
          <div class="hidden md:block item col-span-1 ml-8 md:ml-0 xxl:ml-8">
            <!-- Avatar -->
            <profile-picture
              class="md:hidden xl:block"
              size="max-w-8 w-8 h-8"
              :other-object="item"
            />
            <profile-picture
              class="hidden md:block xl:hidden"
              size="max-w-6 w-6 h-6"
              :other-object="item"
            />
          </div>
          <div
            class="col-span-8 md:col-span-3 xl:col-span-2 xxl:col-span-3 ml-8 md:ml-0 xxl:ml-8 justify-self-start"
          >
            <!-- Personne -->
            <div>
              <p class="text-lg text-gray-900">
                {{ item.firstname }}
                <span class="uppercase">{{ item.lastname }}</span>
              </p>
              <p class="text-sm text-gray-900">
                Crée le
                {{ item.created_at.slice(0, 10) | formatDate }}
              </p>
              <p class="text-sm text-gray-600 font-light">
                Mise à jour le
                {{ item.updated_at.slice(0, 10) | formatDate }}
              </p>
            </div>
          </div>
          <div
            class="hidden md:flex md:col-span-3 2xl:col-span-4 justify-self-start w-full"
          >
            <!-- Droits d'accès -->
            <div
              v-if="item.referents && item.referents.length > 0"
              class="text-sm leading-5 text-gray-600 italic relative"
              @mouseover="displayListReferent(num)"
              @mouseleave="displayListReferent(-1)"
            >
              <transition
                enter-active-class="duration-300"
                enter-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="duration-300"
                leave-class="opacity-100"
                leave-to-class="opacity-0"
              >
                <div
                  v-if="beneficiaryListReferentToDisplay == num"
                  class="absolute bg-indigo-600 text-white flex rounded-lg shadow-lg text-xs z-50 py-5 px-6 bottom-10 left-0 w-max-content w-max max-w-64 md:max-w-72 xxl:max-w-128"
                >
                  <div>
                    <p
                      v-for="(referent, num) in item.referents"
                      :key="num"
                    >
                      {{ referent.firstname }}
                      <span class="uppercase">{{ referent.lastname }}</span>{{ item.referents[++num] == undefined ? '' : ',' }}
                    </p>
                  </div>
                </div>
              </transition>
              <span class="font-semibold">Référent<span v-if="item.referents.length > 1">s</span></span>
              :
              <div class="hidden line-clamp-3">
                <span
                  v-for="(referent, num) in item.referents"
                  :key="num"
                >
                  {{ referent.firstname }}
                  <span class="uppercase">{{ referent.lastname }}</span>{{ item.referents[++num] == undefined ? '' : ',' }}
                </span>
              </div>
            </div>
            <div
              v-else
              class="text-sm leading-5 text-gray-600 italic mr-10"
            >
              Pas de référent
            </div>
          </div>
          <div
            :id="index === 0 ? 'quick-actions' : ''"
            :class="
              'hidden md:flex md:col-span-2 xl:col-span-3 xxl:col-span-2 space-x-0.5 justify-self-start items-between text-orange-600 font-semibold ' +
                (index === 0 ? 'tour_quick_actions' : '')
            "
          >
            <!-- Actions rapides -->
            <circle-button
              v-if="$can(constants.PERMISSION_NEOPASS_PARAMETRES_DROITS_ACCES)"
              icon="person"
              label="Modifier les droits d'accès du bénéficiaire"
              @buttonClick="load_one_beneficiary_rights(item)"
            />

            <div class="relative">
              <circle-button
                icon="printer"
                v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                label="Exporter/Imprimer"
                @buttonClick="displayDropDownExport(item.id)"
              />

              <!-- BEGIN Menu dropdown export -->
              <transition
                enter-active-class="ease-out duration-150"
                enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                leave-active-class="ease-in duration-200"
                leave-class="opacity-100 translate-y-0 sm:scale-100"
                leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <div
                  class="dropDownExportMenu z-20 absolute left-0 top-8 mt-1 p-10 w-max-content w-max ml-auto rounded-md bg-white shadow-md shadow-gray-600 text-sm font-normal"
                  v-if="dropDownExportMenu == item.id"
                  v-clickOutside="forceHide"
                >
                  <h6 class="mb-5 text-gray-900">
                    Quels modules voulez vous exporter ?
                  </h6>
                  <div>
                    <checkbox-indigo
                      name="allModule"
                      libelle="Tout"
                      :value="
                        listModulesToExport.length ==
                          listNeopassModulesPages.length
                      "
                      @input="
                        (newValue) => {
                          selectAllModuleToExport();
                        }
                      "
                    />
                    <checkbox-indigo
                      v-for="(mod, indexMod) in listNeopassModulesPages"
                      :key="indexMod"
                      :name="mod.name"
                      :libelle="mod.display_name"
                      :value="listModulesToExport.includes(mod.id)"
                      @input="
                        (newValue) => {
                          addModuleToExport(mod.id);
                        }
                      "
                      class="ml-5"
                    />
                  </div>
                  <div
                    class="mt-10 flex justify-center"
                    v-if="typeExportInProgress == ''"
                  >
                    <action-button
                      v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                      border-color="border-transparent"
                      text-color="text-white"
                      bg-color="bg-pink-600"
                      libelle="Exporter en PDF"
                      @clickAction="exporter(item, 'neopass')"
                    />
                  </div>
                  <div
                    class="mt-10 flex justify-center"
                    v-else-if="typeExportInProgress == 'neopass'"
                  >
                    <action-button
                      v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                      border-color="border-transparent"
                      text-color="text-white"
                      bg-color="bg-pink-600"
                      libelle="Export en cours"
                      :spinner="true"
                    />
                  </div>
                  <div
                    v-else
                    class="mt-10 flex justify-center"
                  >
                    <action-button
                      v-if="$can(constants.PERMISSION_NEOPASS_EXPORT)"
                      border-color="border-transparent"
                      text-color="text-white"
                      bg-color="bg-gray-600"
                      libelle="Exporter en PDF"
                    />
                  </div>
                </div>
              </transition>
              <!-- END Menu dropdown export -->
            </div>
            <router-link
              :to="{
                name: 'Cartoindcompperso',
                params: { id: item.id },
              }"
              title="Cartographies individuelles"
            >
              <circle-button
                v-if="
                  $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_DISPLAY)
                "
                icon="bar-chart-2"
                label="Cartographies individuelles"
                :enable-click="false"
              />
            </router-link>

            <router-link
              :to="{ name: 'UserHistory', params: { user: item.id } }"
              title="Historique des mouvements"
            >
              <circle-button
                v-if="true"
                icon="file-text"
                label="Historique des mouvements"
                :enable-click="false"
              />
            </router-link>

            <!-- TODO: Distinguer delete et disable -->
            <!--<circle-button icon="power" iconScale="75" v-if="$can('neopass_disable')" label="Désactiver le Neopass"/>-->

            <circle-button
              v-if="$can(constants.PERMISSION_NEOPASS_DETACHER)"
              icon="log-out"
              label="Détacher le Neopass de la structure"
              @buttonClick="openBeneficiaryDetachPopup(item.id)"
            />
          </div>
          <div
            class="col-span-3 md:col-span-3 2xl:col-span-2 md:ml-5 lg:ml-0 mr-0 md:mr-5 lg:mr-0"
          >
            <!-- Modifier le neopass -->
            <router-link
              :to="'/form/neopass/' + item.id"
              class="w-auto"
            >
              <action-button
                border-color="border-transparent"
                text-color="text-gray-900"
                bg-color="bg-indigo-300"
                bg-color-square="bg-white"
                icon-color="text-indigo-600"
                icon="edit"
                :responsive="true"
                libelle="Modifier le carnet"
                :enable-action="false"
              />
            </router-link>
          </div>
        </template>
        <!-- END list of beneficiaries -->
      </list-grid>
    </div>
    <!-- display message when user not allow to use this function -->
    <page-not-allowed v-else />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import ActionButton from './../../components/ActionButton';
import axios from '../../api';
import store from '../../store';
import CircleButton from './../../components/CircleButton';
import PageNotAllowed from './../../components/PageNotAllowed';
import Illustration from './../../components/Illustration';
import CheckboxIndigo from './../../components/Inputs/CheckboxIndigo';
import SortButton from './../../components/SortButton';
import InputSelect from './../../components/Inputs/InputSelect.vue';
import SearchBar from '../../components/Inputs/SearchBar.vue';
import Tag from '../../components/Tag.vue';

import ClickOutside from 'vue-click-outside';
import JsFileDownload from 'js-file-download';
import ProfilePicture from './../../components/ProfilePicture.vue';
import ListGrid from './../../components/AccordionTable/ListGrid.vue';

import Constants from './../../constants';
import AddNewNeopassPopup from '../../components/NeopassList/AddNewNeopassPopup.vue';
import EditBeneficiaryRightsPopup from '../../components/NeopassList/EditBeneficiaryRightsPopup.vue';
import DetachNeopassPopup from '../../components/NeopassList/DetachNeopassPopup.vue';

export default {
  components: {
    ProfilePicture,
    ActionButton,
    CircleButton,
    PageNotAllowed,
    Illustration,
    CheckboxIndigo,
    SortButton,
    InputSelect,
    AddNewNeopassPopup,
    EditBeneficiaryRightsPopup,
    DetachNeopassPopup,
    SearchBar,
    ListGrid,
    Tag,
  },

  name: 'Neopass',

  data() {
    return {
      constants: Constants,

      //neopass: [],
      search: '',
      addNeopassDisplay: -1, // 1: add neopass form / 2: new neopass success / 3: attach neopass success / 4: user not found
      sort: 'ABC',

      // To manage beneficiary rights
      beneficiaryRightsToEdit: {},
      isPopupEditBeneficiaryRightsDisplayed: false,

      beneficiary_out_display: -1, // 1: ask confirmation to detach neopass / 2: detach neopass success
      idBeneficiaryToDetach: -1, //id user beneficiary selected to detach
      neopassToDetach: {},

      messageHeader: '',
      saving: false,

      dropDownExportMenu: -1,
      typeExportInProgress: '',
      listModulesToExport: [],

      beneficiaryListReferentToDisplay: -1,
      searchTypingInterval: 500,
      perPage: 10,

      index: null,
    };
  },

  mounted() {
    this.getNextNeopassOnScroll();
  },

  methods: {
    ...mapMutations({
      SET_PERMISSIONSONBENEFICIARIESNEOPASS:
        'auth/SET_PERMISSIONSONBENEFICIARIESNEOPASS',
      SET_LOADING: 'app/SET_LOADING',
      SET_URLCURSOR: 'beneficiaries/SET_URLCURSOR',
    }),

    ...mapActions({
      loadBeneficiaries: 'beneficiaries/loadBeneficiaries',
      loadBeneficiaryRights: 'beneficiaries/loadBeneficiaryRights',
      changeStructure: 'auth/changeStructure',
      me: 'auth/me',
    }),

    onKeyDown() {
      clearTimeout(this.timer);
    },

    onKeyUp() {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.doneTyping, this.searchTypingInterval);
    },

    doneTyping() {
      //reset cursor for init pagination
      this.SET_URLCURSOR('');
      this.loadBeneficiaries({
        hasPagination: 1,
        search: this.search,
        orderBy: this.orderBy,
        direction: this.direction,
        perPage: this.perPage,
      });
    },

    nextBeneficiaries() {
      this.loadBeneficiaries({
        hasPagination: 1,
        search: this.search,
        orderBy: this.orderBy,
        direction: this.direction,
        perPage: this.perPage,
      });
    },

    async detachNeopass(id) {
      this.beneficiary_out_display = -1;
      store.commit('app/SET_LOADING', true);

      await axios.put('/api/beneficiaries/detach/' + id).then((response) => {
        this.loadBeneficiaries({
          hasLoading: true,
          hasPagination: 1,
          orderBy: this.orderBy,
          direction: this.direction,
          perPage: this.perPage,
        }).then((r) => {
          store.commit('app/SET_LOADING', false);
          this.beneficiary_out_display = 2;
        });
      });
    },

    openPopupNewNeopass() {
      this.addNeopassDisplay = 1;
      this.saving = false;
    },

    async load_one_beneficiary_rights(beneficiary) {
      await this.loadBeneficiaryRights(beneficiary.id).then((response) => {
        let b = { ...beneficiary };
        b.rights = response;

        this.beneficiaryRightsToEdit = b;

        this.changeStateEditBeneficiaryRightsPopup(true);
      });
    },

    /**
     * Save beneficiary rights
     * @param {*} context
     * @param int id
     */
    async save_beneficiary_rights() {
      this.saving = true;
      await axios
        .put('/api/user-rights/' + this.beneficiaryRightsToEdit.id, {
          rights: this.beneficiaryRightsToEdit.rights,
        })
        .then((response) => {
          this.messageHeader = 'saveIsSuccess';
          this.saving = false;
          setTimeout(() => {
            this.messageHeader = '';
          }, 3000);
        })
        .catch((error) => {
          this.messageHeader = 'error';
          setTimeout(() => {
            this.messageHeader = '';
          }, 3000);
          console.log('ERRRR:: ', error.response.data);
        });
    },

    changeStateEditBeneficiaryRightsPopup(state) {
      this.isPopupEditBeneficiaryRightsDisplayed = state;

      if (!state) {
        this.saving = false;
        this.beneficiaryRightsToEdit = {};
      }
    },

    openBeneficiaryDetachPopup(id) {
      this.beneficiary_out_display = 1;

      this.neopassToDetach = this.neopass.filter((p) => p.id == id)[0];
    },

    closePopupDetachNeopass() {
      this.beneficiary_out_display = -1;
      this.neopassToDetach = {};
    },

    checkall(readOrEdit, moduleName, state) {
      if (moduleName == 'all') {
        for (let mod in this.beneficiaryRightsToEdit.rights.neopassForm[
          readOrEdit
        ]) {
          if (mod != 'all') {
            for (var page in this.beneficiaryRightsToEdit.rights.neopassForm[
              readOrEdit
            ][mod]) {
              this.beneficiaryRightsToEdit.rights.neopassForm[readOrEdit][mod][
                page
              ] = state;
            }
          }
        }
      } else {
        for (var page in this.beneficiaryRightsToEdit.rights.neopassForm[
          readOrEdit
        ][moduleName]) {
          if (page != 'all') {
            this.beneficiaryRightsToEdit.rights.neopassForm[readOrEdit][
              moduleName
            ][page] = state;
          }
        }
      }
    },

    decheckall(readOrEdit, moduleName, state) {
      if (this.beneficiaryRightsToEdit.rights.neopassForm[readOrEdit].all) {
        this.beneficiaryRightsToEdit.rights.neopassForm[readOrEdit].all = state;
      }

      if (
        this.beneficiaryRightsToEdit.rights.neopassForm[readOrEdit][moduleName]
          .all
      ) {
        this.beneficiaryRightsToEdit.rights.neopassForm[readOrEdit][
          moduleName
        ].all = state;
      }
    },

    displayDropDownExport(id) {
      this.dropDownExportMenu = id;
    },

    addModuleToExport(id) {
      if (this.listModulesToExport.includes(id)) {
        let idToDelete = Object.keys(this.listModulesToExport).find(
          (key) => this.listModulesToExport[key] === id
        )[0];
        this.listModulesToExport.splice(idToDelete, 1);
      } else if (!this.listModulesToExport.includes(id)) {
        this.listModulesToExport.push(id);
      }
    },

    forceHide(e) {
      this.listModulesToExport = [];

      if (!e.target.classList.contains('dropDownExportMenu')) {
        if (this.dropDownExportMenu > -1) {
          this.dropDownExportMenu = -1;
        }
      }
    },

    async exporter(benficiary, type) {
      this.typeExportInProgress = type;

      await axios({
        url: `/api/pdf/neopass/${benficiary.id}`,
        method: 'POST',
        responseType: 'blob', // Important
        data: {
          listModules: this.listModulesToExport,
        },
      }).then((response) => {
        let filename = `${benficiary.firstname} ${benficiary.lastname}.pdf`;

        if (this.listModulesToExport.length > 1) {
          filename = `Neopass - ${filename}`;
        }
        if (this.listModulesToExport.length === 1) {
          let displayName = this.listNeopassModulesPages.filter(
            (module) => module.id === this.listModulesToExport[0]
          )[0].display_name;

          filename = `${displayName ?? 'Neopass'} - ${filename}`;
        }
        JsFileDownload(response.data, filename);
        this.typeExportInProgress = '';
      });
    },

    displayListReferent(index) {
      this.beneficiaryListReferentToDisplay = index;
    },

    selectAllModuleToExport() {
      if (
        this.listNeopassModulesPages.length == this.listModulesToExport.length
      ) {
        this.listModulesToExport = [];
      } else {
        this.listModulesToExport = this.listNeopassModulesPages.map(
          (m) => m['id']
        );
      }
    },

    async changeStructureAndReloadInfos(idStructure) {
      await this.changeStructure(idStructure);
      this.$router.go();
    },

    /**
     * Pagination with infinite scroll
     */
    getNextNeopassOnScroll() {
      let mainContent = document.getElementById('main-content');

      mainContent.onscroll = () => {
        let bottomOfWindow =
          mainContent.scrollTop + mainContent.offsetHeight ===
          mainContent.scrollHeight;

        if (bottomOfWindow && this.$route.name === 'Neopass') {
          this.nextBeneficiaries();
        }
      };
    },

    changeSortType(sortType) {
      this.SET_URLCURSOR('');
      this.sort = sortType;

      this.loadBeneficiaries({
        hasPagination: 1,
        search: this.search,
        orderBy: this.orderBy,
        direction: this.direction,
        perPage: this.perPage,
      });
    },

    changePerPage(numberPages) {
      this.SET_URLCURSOR('');
      this.perPage = numberPages;

      this.loadBeneficiaries({
        hasPagination: 1,
        search: this.search,
        orderBy: this.orderBy,
        direction: this.direction,
        perPage: this.perPage,
      });
    },
  },

  computed: {
    ...mapGetters({
      allowed: 'app/allowed',
      permissionsOnBeneficiariesNeopass:
        'auth/permissionsOnBeneficiariesNeopass',
      listNeopassModulesPages: 'permissions/listNeopassModulesPages',
      permissions: 'auth/permissions',
      neopass: 'beneficiaries/beneficiaries',
      urlCursor: 'beneficiaries/urlCursor',
      user: 'auth/user',
      structure: 'auth/structure',
    }),

    structures() {
      return this.user.companies.reduce(
        (acc, company) => [...acc, { ...company, value: company.name }],
        []
      );
    },

    orderBy() {
      switch (this.sort) {
      case 'ABC':
      case 'ZYX':
        return 'lastname';

      case 'JAN':
      case 'DEC':
        return 'created_at';
      default:
        return 'lastname';
      }
    },

    direction() {
      switch (this.sort) {
      case 'ABC':
      case 'JAN':
        return 'ASC';

      case 'ZYX':
      case 'DEC':
        return 'DESC';
      default:
        return 'ASC';
      }
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
